import { Currency } from '../model'
import { WETH_DAI, WETH_LINK, WETH_USDC, WETH_USDT, WETH_WBTC, DAI_USDC, DAI_USDT, USDC_USDT } from './addresses'
import { ChainId } from './chainId'
import {
  Wbtc,
  Usdc,
  Usdt,
  Dai,
  Weth,
  Link,
  KovanWeth,
  KovanWrappedBitcoin,
  KovanUSDCoin,
  KovanTetherUSD,
  KovanDai,
  KovanLink,
  GanacheWeth,
  GanacheWrappedBitcoin,
  GanacheUSDCoin,
  GanacheTetherUSD,
  GanacheDai,
  GanacheLink,
} from './currencies'

export interface PairsItem {
  address: string
  tokens: Currency[]
}

export const MAINNET_PAIRS: PairsItem[] = [
  { address: WETH_WBTC[ChainId.Mainnet], tokens: [Weth, Wbtc] },
  { address: WETH_USDC[ChainId.Mainnet], tokens: [Weth, Usdc] },
  { address: WETH_USDT[ChainId.Mainnet], tokens: [Weth, Usdt] },
  { address: WETH_DAI[ChainId.Mainnet], tokens: [Weth, Dai] },
  { address: WETH_LINK[ChainId.Mainnet], tokens: [Weth, Link] },
  { address: DAI_USDC[ChainId.Mainnet], tokens: [Dai, Usdc] },
  { address: DAI_USDT[ChainId.Mainnet], tokens: [Dai, Usdt] },
  { address: USDC_USDT[ChainId.Mainnet], tokens: [Usdc, Usdt] },
]

export const KOVAN_PAIRS: PairsItem[] = [
  { address: WETH_WBTC[ChainId.Kovan], tokens: [KovanWeth, KovanWrappedBitcoin] },
  { address: WETH_USDC[ChainId.Kovan], tokens: [KovanWeth, KovanUSDCoin] },
  { address: WETH_USDT[ChainId.Kovan], tokens: [KovanWeth, KovanTetherUSD] },
  { address: WETH_DAI[ChainId.Kovan], tokens: [KovanWeth, KovanDai] },
  { address: WETH_LINK[ChainId.Kovan], tokens: [KovanWeth, KovanLink] },
  { address: DAI_USDC[ChainId.Kovan], tokens: [KovanDai, KovanUSDCoin] },
  { address: DAI_USDT[ChainId.Kovan], tokens: [KovanDai, KovanTetherUSD] },
  { address: USDC_USDT[ChainId.Kovan], tokens: [KovanUSDCoin, KovanTetherUSD] },
]

export const GANACHE_PAIRS: PairsItem[] = [
  { address: WETH_WBTC[ChainId.Ganache], tokens: [GanacheWeth, GanacheWrappedBitcoin] },
  { address: WETH_USDC[ChainId.Ganache], tokens: [GanacheWeth, GanacheUSDCoin] },
  { address: WETH_USDT[ChainId.Ganache], tokens: [GanacheWeth, GanacheTetherUSD] },
  { address: WETH_DAI[ChainId.Ganache], tokens: [GanacheWeth, GanacheDai] },
  { address: WETH_LINK[ChainId.Ganache], tokens: [GanacheWeth, GanacheLink] },
  { address: DAI_USDC[ChainId.Ganache], tokens: [GanacheDai, GanacheUSDCoin] },
  { address: DAI_USDT[ChainId.Ganache], tokens: [GanacheDai, GanacheTetherUSD] },
  { address: USDC_USDT[ChainId.Ganache], tokens: [GanacheUSDCoin, GanacheTetherUSD] },
]

export const PAIRS: PairsItem[] = [
  // mainnet
  ...MAINNET_PAIRS,
  // kovan
  ...KOVAN_PAIRS,
  // ganache
  ...GANACHE_PAIRS,
]

export const PAIRS_BY_CHAIN = {
  [ChainId.Mainnet]: MAINNET_PAIRS,
  [ChainId.Kovan]: KOVAN_PAIRS,
  [ChainId.Ganache]: GANACHE_PAIRS,
}

export const DEFAULT_PAIRS = {
  [ChainId.Mainnet]: MAINNET_PAIRS[1],
  [ChainId.Kovan]: KOVAN_PAIRS[1],
  [ChainId.Ganache]: GANACHE_PAIRS[1],
}

// Mainnet restrictions
export const DISABLE_TRADING: string[] = [
  '0x5dFAe56E344B18bC7cd3B8350721FfdD12Ff2b3C',
  '0x8b0Bb0d0D8B3D83EBb7c1B49d79D74dF396634c6',
  '0x3eD27247A8abF40d3D85171536ea98e5eEd94F40',
  '0x5FB51deDd29b8C065cA3Ac4545b6c58b635616C5',
  '0x4370CFD2c62b6E2900D04af97c4D9552484C0e48',
  '0x01d9984489bD4c5f372a6e6Eca1F22c27A77e355',
  '0xcddD3B9EACce44DDf9d5748C8e8b5F8d630f17EB',
  '0x3fFecc12a6B46C3Aa32aEA38ac34EfbB6C9B6052',
].map((pair) => pair.toLowerCase())

export const DISABLE_DEPOSIT: string[] = [
  '0x5dFAe56E344B18bC7cd3B8350721FfdD12Ff2b3C',
  '0x8b0Bb0d0D8B3D83EBb7c1B49d79D74dF396634c6',
  '0x3eD27247A8abF40d3D85171536ea98e5eEd94F40',
  '0x5FB51deDd29b8C065cA3Ac4545b6c58b635616C5',
  '0x4370CFD2c62b6E2900D04af97c4D9552484C0e48',
  '0x01d9984489bD4c5f372a6e6Eca1F22c27A77e355',
  '0xcddD3B9EACce44DDf9d5748C8e8b5F8d630f17EB',
  '0x3fFecc12a6B46C3Aa32aEA38ac34EfbB6C9B6052',
].map((pair) => pair.toLowerCase())

export const DISABLE_WITHDRAW: string[] = []
